<template>
    <blank-layout>


        <div class="-mt-6 flex flex-grow flex-col relative">

            <div class="w-full h-full grid grid-cols-2 bg-red-200">

                <div class="bg-birdie-dark text-white flex flex-col h-full w-full items-center justify-center bg-no-repeat bg-center bg-cover"
                    style="background-image: url('/img/bg-curtain-dark.png');">

                    <transition name="fade">
                        <div v-if="!recording_started" class=" flex py-5 flex-col justify-center items-center w-full text-center text-2xl md:text-4xl
                            lg:text-5xl font-bold font-jakarta">
                            Let's make your first <br /><span class="text-gradient-blue pb-4 ">Screen Recording!</span>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-if="!recording_started"
                            class="py-3 w-full text-center text-md lg:text-lg font-semibold font-jakarta">
                            <span class="text-gradient-blue">Lauch Birdie extension</span> and click “Start Recording”.
                            <br />
                            No pressure — This is just for practice!
                        </div>
                    </transition>
                    <!-- <div v-if="isPinned && pinStateKnown"
                        class="flex py-5  flex-col justify-center items-center w-full">
                        Extension is pinned
                    </div>
                    <div v-else-if="pinStateKnown" class="flex py-5 flex-col justify-center items-center w-full">
                        Extension is *not* pinned
                    </div>
                    <div v-else class="flex py-5  flex-col justify-center items-center w-full">
                        &nbsp;
                    </div> -->

                </div>
                <div class="bg-white">
                    <div class="flex flex-col h-full w-full items-center justify-between ">
                        <div class="pt-20 w-full flex-grow justify-center items-center relative">
                            <transition name="fade">
                                <div v-if="!recording_started" class="flex w-full justify-end absolute top-20 right-36">
                                    <CurvedArrowDraw />
                                </div>
                            </transition>
                            <transition name="fade">
                                <div v-if="recording_started && !recording_done"
                                    class="flex w-full h-full flex-col flex-grow items-start justify-center relative">
                                    <div
                                        class="w-full max-w-md mx-auto text-center border border-gray-300 rounded-md p-4 text-base font-medium">
                                        Nice work! You’re recording now - browse any page, and when you’re done, just
                                        hit stop.
                                    </div>

                                    <div class="flex absolute -bottom-12 left-0 scale-y-[-1] rotate-45 ">
                                        <CurvedArrowFixedBlue class="-rotate-[20deg] scale-50" />
                                    </div>

                                </div>
                            </transition>
                            <transition name="fade">
                                <div v-if="recording_started && recording_done"
                                    class="flex w-full h-full flex-col flex-grow items-start justify-center relative">
                                    <div
                                        class="w-full max-w-md mx-auto text-center border border-gray-300 rounded-md p-4 text-base font-medium">
                                        Your first recording is ready! The link is copied to your clipboard, and we’ve
                                        opened a new tab with your recording.
                                    </div>
                                </div>
                            </transition>
                        </div>
                        <div class="pb-20 w-full text-center">
                            <jet-secondary-button class="md:min-w-1/2 justify-center font-bold" @click="skipToLibrary()"
                                style="height:42px">
                                Skip to Library
                            </jet-secondary-button>
                        </div>
                    </div>
                </div>

            </div>

            <extension-pin-overlay :is_extension_loaded="extension_loaded" @close="closeExtensionPinOverlay" />

        </div>



    </blank-layout>

</template>

<script>

import BlankLayout from "@/Layouts/BlankLayout"
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import { router } from '@inertiajs/vue3'
import ExtensionPinOverlay from '@/Components/UI/ExtensionPinOverlay'
import CurvedArrowDraw from '@/Components/UI/CurvedArrowDrawBlue'
import CurvedArrowFixedBlue from '@/Components/UI/CurvedArrowFixedBlue'
export default {

    props: [

    ],

    components: {
        BlankLayout, JetSecondaryButton, ExtensionPinOverlay, CurvedArrowDraw, CurvedArrowFixedBlue

    },
    data() {
        return {
            user_id: null,
            user_token: null,
            user_email: null,
            extension_loaded: window.extension_loaded || false,
            user_authenticated: window.extension_user || false,
            loading: false,
            extension_pin_overlay_open: true,
            recording_started: false,
            recording_done: false,
            network_calls_ongoing: false,
            console_logs_ongoing: false,
        }
    },
    created() {
        document.addEventListener('EXTENSION_RESPONSE', this.handleExtensionResponse);
        document.addEventListener('EXTENSION_ACTIVITY', this.handleExtensionActivity);

    },
    beforeUnmount() {
        document.removeEventListener('EXTENSION_RESPONSE', this.handleExtensionResponse);
        document.removeEventListener('EXTENSION_ACTIVITY', this.handleExtensionActivity);
    },
    mounted() {
        if (!this.user_authenticated) {
            document.dispatchEvent(new CustomEvent('GET_EXTENSION_STATE', {
                detail: {}
            }));
        }
    },
    computed: {
        is_chrome() {
            const ua = navigator.userAgent;
            const vendor = navigator.vendor;
            return ua.includes("Chrome") && vendor === "Google Inc.";
        },
    },
    methods: {
        triggerSomeLogs() {
            if (this.console_logs_ongoing) {
                return
            }
            this.console_logs_ongoing = true
            setTimeout(() => {
                console.log('🎥 Welcome to Birdie! Your recording has started');
                console.info('ℹ️ Pro tip: You can stop recording anytime by clicking the extension icon');
            }, 1000);
            setTimeout(() => {
                console.warn('⚠️ Remember: This is just a practice recording');
                console.debug('🔍 Debug: Recording started at:', new Date().toLocaleTimeString());
            }, 1500);
            setTimeout(() => {
                console.group('📊 Recording Details');
                console.log('Browser:', this.is_chrome ? 'Chrome' : 'Other');
                console.log('Extension Status:', this.extension_loaded ? 'Loaded' : 'Not Loaded');
                console.groupEnd();
            }, 2000);
        },
        triggerSomeNetworkCalls() {
            if (this.network_calls_ongoing) {
                return
            }
            this.network_calls_ongoing = true
            function fetchGet() {
                fetch('https://jsonplaceholder.typicode.com/posts/1')
                    .then(response => response.json())
                    //.then(data => console.log('Fetch GET Response:', data))
                    .catch(error => console.error('Fetch GET Error:', error));
            }
            function fetch403() {
                fetch('ttps://httpbin.org/status/403')
                    .then(response => response.json())
                    //.then(data => console.log('Fetch GET Response:', data))
                    .catch(error => console.error('Fetch GET Error:', error));
            }
            function fetch500() {
                fetch('https://httpbin.org/status/500')
                    .then(response => response.json())
                    //.then(data => console.log('Fetch GET Response:', data))
                    .catch(error => console.error('Fetch GET Error:', error));
            }
            function fetch300() {
                fetch('https://httpbin.org/redirect/1')
                    .then(response => response.json())
                    //.then(data => console.log('Fetch GET Response:', data))
                    .catch(error => console.error('Fetch GET Error:', error));
            }

            function xhrGet() {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', 'https://jsonplaceholder.typicode.com/users', true);
                xhr.onload = function () {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        //console.log('XHR GET Response:', JSON.parse(xhr.responseText));
                    } else {
                        console.error('XHR GET Error:', xhr.statusText);
                    }
                };
                xhr.onerror = function () {
                    console.error('XHR GET Network error.');
                };
                xhr.send();
            }
            function fetchPost() {
                fetch('https://jsonplaceholder.typicode.com/posts', {
                    method: 'POST',
                    body: JSON.stringify({
                        title: 'foo',
                        body: 'bar',
                        userId: 1,
                    }),
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    },
                })
                    .then(response => response.json())
                    //.then(data => console.log('Fetch POST Response:', data))
                    .catch(error => console.error('Fetch POST Error:', error));
            }

            function xhrPost() {
                var xhr = new XMLHttpRequest();
                xhr.open('POST', 'https://jsonplaceholder.typicode.com/posts', true);
                xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
                xhr.onload = function () {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        //console.log('XHR POST Response:', JSON.parse(xhr.responseText));
                    } else {
                        console.error('XHR POST Error:', xhr.statusText);
                    }
                };
                xhr.onerror = function () {
                    console.error('XHR POST Network error.');
                };
                xhr.send(JSON.stringify({
                    title: 'foo',
                    body: 'bar',
                    userId: 1,
                }));
            }
            function fetchPut() {
                fetch('https://jsonplaceholder.typicode.com/posts/1', {
                    method: 'PUT',
                    body: JSON.stringify({
                        id: 1,
                        title: 'foo',
                        body: 'bar',
                        userId: 1,
                    }),
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    },
                })
                    .then(response => response.json())
                    //.then(data => console.log('Fetch PUT Response:', data))
                    .catch(error => console.error('Fetch PUT Error:', error));
            }
            function fetchDelete() {
                fetch('https://jsonplaceholder.typicode.com/posts/1', {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    //.then(data => console.log('Fetch DELETE Response:', data))
                    .catch(error => console.error('Fetch DELETE Error:', error));
            }
            setTimeout(function () {
                fetchGet();
            }, 1000);
            setTimeout(function () {
                xhrGet();
            }, 1500);
            setTimeout(function () {
                fetchPost();
            }, 1800);
            setTimeout(function () {
                xhrPost();
            }, 2000);
            setTimeout(function () {
                fetchPut();
            }, 2500);
            setTimeout(function () {
                fetchDelete();
            }, 3000);

            setTimeout(function () {
                fetch400();
            }, 3500);
            setTimeout(function () {
                fetch300();
            }, 4000);
            setTimeout(function () {
                fetch500();
            }, 4500);

        },
        closeExtensionPinOverlay() {
            //console.log("closeExtensionPinOverlay")
            this.extension_pin_overlay_open = false
        },
        handleExtensionActivity(response) {
            //console.log("handleExtensionActivity", response.detail)
            if (response.detail.type == "recording-has-started") {
                this.recording_started = true
                this.triggerSomeLogs()
                this.triggerSomeNetworkCalls()
            } else if (this.recording_started && response.detail.type == "recorder-has-stopped") {
                this.recording_done = true
                document.removeEventListener('EXTENSION_RESPONSE', this.handleExtensionResponse);
                document.removeEventListener('EXTENSION_ACTIVITY', this.handleExtensionActivity);
                this.network_calls_ongoing = false
                this.console_logs_ongoing = false
            }
        },
        handleExtensionResponse(response) {
            // console.log("handleExtensionResponse", response.detail)
            this.extension_loaded = true
            window.extension_loaded = true
            if (response.detail.userEmail) {
                this.user_authenticated = true
                window.extension_user = response.detail.userEmail
            }
            if (!this.user_authenticated) {
                this.getUserAuth()
            }
        },
        getUserAuth() {
            if (this.loading || this.user_id) {
                return
            }
            this.loading = true
            let url = this.$page.props.api_url + '/v1/welcome/extension/auth'
            const params = {}
            axios.post(url, params)
                .then(response => {
                    // console.log("axios", response.data);
                    if (response.data) {
                        this.user_id = response.data.user_id
                        this.user_token = response.data.user_token
                        this.user_email = response.data.user_email
                        document.dispatchEvent(new CustomEvent('USER_DATA_READY', {
                            detail: {
                                userId: this.user_id,
                                token: this.user_token,
                                email: this.user_email
                            }
                        }));
                        this.loading = false
                    }
                })
                .catch(e => {
                    console.error(e);
                    this.loading = false
                });
        },
        skipToLibrary() {
            router.visit(route('library.personal'));
        }
    }
}
</script>

<style scoped>
.sidebar_gradient {
    background: -webkit-linear-gradient(#fafbfc, #e2e5e7);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}


.slide-fade-enter-active {
    transition: all .3s ease-out;
}

.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}

.text-gradient-blue {
    -webkit-text-fill-color: transparent;
    background-image: linear-gradient(90deg, #70dcff, #006dff), linear-gradient(#000, #fff);
    -webkit-background-clip: text;
    background-clip: text;
}

.text-gradient-purple {
    -webkit-text-fill-color: transparent;
    background-image: linear-gradient(90deg, #D6B6FF, #B250FF), linear-gradient(#000, #fff);
    -webkit-background-clip: text;
    background-clip: text;
}
</style>
